module.exports = __webpack_public_path__ + "static/media/blog-1.58a42f37.jpg";